import React, { useState, useEffect } from "react";
import { Collapse, Row, Col, Table } from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import LineOption from "./LineOption";

export default function DropOption(props) {
  const {
    data,
    allScreens,
    productsWithActions,
    setProductsWithActions,
    profileId,
  } = props;
  // states
  const [isOpen, setIsOption] = useState(false);
  const [canViewAll, setCanViewAll] = useState(false);
  const [canCreateAll, setCanCreateAll] = useState(false);
  const [canEditAll, setCanEditAll] = useState(false);
  const [canDeleteAll, setCanDeleteAll] = useState(false);
  const [canAll, setCanAll] = useState(false);

  async function changeAllAction(can, value) {
    // telas do produto
    const screenListByProduct = allScreens.filter(
      (e) => e.idmainproduct === data.id
    );
    // telas do produto com alguma opcao marcada
    var screensWithActionsByProduct = productsWithActions.filter(
      (e) => e.productId === data.id
      // (e) => e.product === data.name
    );

    // consultar se todas as telas do produto estão no array de ações para adicionar ou atualizar
    screenListByProduct.forEach(async (element, index) => {
      const search = screensWithActionsByProduct.find(
        (e) => e.screenId === element.id
      );

      if (search) {
        // se tiver, esse obj é atualizado
        const position = screensWithActionsByProduct.findIndex(
          (e) => e.screenId === element.id
        );

        if (can === "canAll") {
          screensWithActionsByProduct[position] = {
            ...screensWithActionsByProduct[position],
            canView: value,
            canCreate: value,
            canEdit: value,
            canDelete: value,
          };
        } else {
          screensWithActionsByProduct[position] = {
            ...screensWithActionsByProduct[position],
            [can]: value,
          };
        }
      } else {
        // caso não, ele é inserido com as informações básicas + a opção marcada na coluna
        if (can === "canAll") {
          screensWithActionsByProduct.push({
            productId: element.idmainproduct,
            screenId: element.id,
            screenName: element.screenname,
            namemainproduct: element.namemainproduct,
            product: data.name,
            canView: value,
            canCreate: value,
            canEdit: value,
            canDelete: value,
          });
        } else {
          screensWithActionsByProduct.push({
            productId: element.idmainproduct,
            screenId: element.id,
            screenName: element.screenname,
            namemainproduct: element.namemainproduct,
            product: data.name,
            [can]: value,
          });
        }
      }
    });

    // preservar os objetos do array sem o filtro feito na declaração da variável
    screensWithActionsByProduct.push(
      ...productsWithActions.filter((e) => e.productId !== data.id)
    );

    // array atualizado salvo no state
    setProductsWithActions(
      screensWithActionsByProduct.filter(
        (e) => e.canCreate || e.canDelete || e.canEdit || e.canView
      )
    );
  }

  // função para mudar os valores ao selecionar uma opção de tela
  function setStateData({ can, value, screenData }) {
    var screenActions = productsWithActions;

    // ver se a tela alterada está na lista
    const searchScreen = screenActions.find(
      (e) =>
        e.screenId === screenData.id && e.productId === screenData.idmainproduct
    );

    if (searchScreen) {
      // se tiver, ele é atualizado pela posição do index buscado na função abaixo
      const position = screenActions.findIndex(
        (e) =>
          e.screenId === screenData.id &&
          e.productId === screenData.idmainproduct
      );

      screenActions[position] = {
        ...searchScreen,
        [can]: value,
        namemainproduct: screenData.namemainproduct,
        productId: screenData.idmainproduct,
      };
    } else {
      // se não, é inserido com a estrutura inicial
      screenActions.push({
        productId: screenData.idmainproduct,
        screenId: screenData.id,
        namemainproduct: screenData.namemainproduct,
        screenName: screenData.screenname,
        product: data.name,
        [can]: value,
      });
    }

    // salvar apenas os objetos com alguma ação selecionada e finalizar o processo
    setProductsWithActions(
      screenActions.filter(
        (e) => e.canCreate || e.canDelete || e.canEdit || e.canView
      )
    );
  }

  // função para atualizar o atualizar check da coluna
  function checkActionAll() {
    // telas do produto
    const screensByProduct = allScreens.filter(
      (e) => e.idmainproduct === data.id
    );

    // telas do produto com alguma opção marcada
    const screensWithActions = productsWithActions.filter(
      (e) => e.productId === data.id
    );

    const searchView = screensWithActions.filter(
      (e) => e.canView || e.canCreate || e.canEdit || e.canDelete
    );

    if (screensByProduct.length === searchView.length) {
      setCanViewAll(true);
    } else setCanViewAll(false);

    const searchCreate = screensWithActions.filter((e) => e.canCreate);

    if (screensByProduct.length === searchCreate.length) {
      setCanCreateAll(true);
    } else setCanCreateAll(false);

    const searchEdit = screensWithActions.filter((e) => e.canEdit);

    if (screensByProduct.length === searchEdit.length) {
      setCanEditAll(true);
    } else setCanEditAll(false);

    const searchDelete = screensWithActions.filter((e) => e.canDelete);

    if (screensByProduct.length === searchDelete.length) {
      setCanDeleteAll(true);
    } else setCanDeleteAll(false);
  }

  useEffect(() => {
    checkActionAll();
  }, [productsWithActions]);

  // controlar o marcador selecionar todos
  useEffect(() => {
    if (canCreateAll && canDeleteAll) {
      setCanAll(true);
    } else setCanAll(false);
  }, [canCreateAll, canDeleteAll]);

  return (
    <>
      <Row>
        <SectionComponent
          sectionName={data.name}
          setIsOpen={setIsOption}
          isOpen={isOpen}
        />

        <Collapse isOpen={isOpen}>
          <Row>
            <Col md={12}>
              <div className="table-responsive">
                <Table className="table">
                  <thead className="table-light">
                    <tr>
                      <th className="text-center">
                        <label>Tela</label>
                      </th>
                      <th className="text-center">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label htmlFor="CanViewAll">Pode Visualizar?</label>{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              changeAllAction("canView", e.target.checked);
                            }}
                            id="CanViewAll"
                            checked={
                              canViewAll ||
                              canCreateAll ||
                              canEditAll ||
                              canDeleteAll
                            }
                            disabled={
                              canCreateAll || canEditAll || canDeleteAll
                            }
                          />
                        </div>
                      </th>
                      <th className="text-center">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label htmlFor="CanCreateAll">Pode Criar?</label>{" "}
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              changeAllAction("canCreate", e.target.checked)
                            }
                            checked={canCreateAll}
                            id="CanCreateAll"
                          />
                        </div>
                      </th>
                      <th className="text-center">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label htmlFor="CanEditAll">Pode Editar?</label>{" "}
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              changeAllAction("canEdit", e.target.checked)
                            }
                            id="CanEditAll"
                            checked={canEditAll || canCreateAll}
                            disabled={canCreateAll}
                          />
                        </div>
                      </th>
                      <th className="text-center">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label htmlFor="CanDeleteAll">Pode Excluir?</label>{" "}
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              changeAllAction("canDelete", e.target.checked)
                            }
                            checked={canDeleteAll}
                            id="CanDeleteAll"
                          />
                        </div>
                      </th>
                      <th className="text-center">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label htmlFor="selectAll">Selecionar Todos</label>
                          <input
                            type="checkbox"
                            id="selectAll"
                            checked={canAll}
                            onChange={async (e) => {
                              const value = e.target.checked;
                              setCanAll(value);
                              changeAllAction("canAll", value);
                            }}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {allScreens &&
                      allScreens.length > 0 &&
                      allScreens
                        .filter((e) => e.idmainproduct === data.id)
                        .map((e, i) => (
                          <LineOption
                            data={e}
                            setStateData={setStateData}
                            productsWithActions={productsWithActions}
                            productName={data.name}
                          />
                        ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Collapse>
      </Row>
    </>
  );
}
